const signupErrors: Record<string, string> = {
    'auth/email-already-exists': 'Indirizzo email giá in uso',
    'auth/invalid-email': 'Indirizzo email ma formattata',
    'auth/invalid-password': "La password non rispetta i criteri minimi di sicurezza",
    'auth/invalid-phone-number': 'Numero di telefono mal formattato',
    'auth/phone-number-already-exists': 'Numero di telefono giá in uso',
};

export { signupErrors };
